import { createAsyncThunk } from '@reduxjs/toolkit';
import { PushNotificationManagement } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchPushNotificationManagement, FindPushNotificationManagement, GetPushNotificationManagement } from './interface';
import { toast } from 'react-toastify';

export const findPushNotificationManagement = createAsyncThunk(
  'PushNotificationManagement/findPushNotificationManagement',
  async (values: FindPushNotificationManagement, { rejectWithValue }) => {
    try {
      const response = await PushNotificationManagement.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createPushNotificationManagement = createAsyncThunk(
  'PushNotificationManagement/createPushNotificationManagement',
  async (values: CreatePatchPushNotificationManagement, { rejectWithValue }) => {
    try {
      const response = await PushNotificationManagement.create(values);
      if (response?.message) {
        toast.success(response?.message);
      }
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchPushNotificationManagement = createAsyncThunk(
  'PushNotificationManagement/patchPushNotificationManagement',
  async ({ id, ...values }: CreatePatchPushNotificationManagement, { rejectWithValue }) => {
    try {
      const response = await PushNotificationManagement.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getPushNotificationManagement = createAsyncThunk(
  'PushNotificationManagement/getPushNotificationManagement',
  async ({ id }: GetPushNotificationManagement, { rejectWithValue }) => {
    try {
      const response = await PushNotificationManagement.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);